import React from 'react'

const Color = () => {
  return (
    <div className="mace-color">
      <h4>color</h4>
      <div className="mace-color_content flex">
        <div className="mace-color_content-box"></div>
        <p>
          A single color scheme was used throughout the application, its the color used by the company.
          For the design the color was retained in order to deliver the tone of the Mace brand to users of the app.
        </p>
      </div>
    </div>
  )
}

export default Color